module.exports = __webpack_public_path__ + "img/P21.f99f933f.png";